var ezdia;
(function (ezdia) {
    var stepReviewFields = function (context) {
        var e_1, _a;
        var ret = '';
        var count = 1;
        try {
            for (var context_1 = __values(context), context_1_1 = context_1.next(); !context_1_1.done; context_1_1 = context_1.next()) {
                var col = context_1_1.value;
                var column = col.column;
                ret += "<div class=\"clearfix question\">\n        <div class=\"text-muted\">Question " + count + ":</div>\n        <div class=\"form-group\">\n          <div class=\"control-label\" id=\"" + column.name + "_label\">" + (column.labelInfo || column.label) + "</div>\n          <div class=\"inputs\">\n            <div class=\"form-control-static\"><b class=\"text-success\">Your answer is: </b> " + $.ezdia.inputs.readonlyView(col) + "</div>\n          </div>\n        </div>\n      </div>";
                count += 1;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (context_1_1 && !context_1_1.done && (_a = context_1.return)) _a.call(context_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return ret;
    };
    var stepReview = function (context) {
        var href = context.href, bodyId = context.bodyId, panelId = context.panelId, label = context.label, fileds = context.fileds, index = context.index;
        var ret = "<div id=\"" + panelId + "\"  class=\"panel ez-form-fields-grp\">\n      <div class=\"panel-heading\" data-toggle=\"collapse\" href=\"" + href + "\">\n        <i class=\"fa fa-angle-up\"></i> " + label + "\n        <a class=\"btn-circle btn-circle-sm btn-default pull-right\" data-index=\"" + index + "\" data-action=\"edit\"><i class=\"fa fa-pencil\"></i></a>\n      </div>\n      <div id=\"" + bodyId + "\" class=\"panel-body collapse in\">" + stepReviewFields(fileds) + "</div>\n    </div>";
        return ret;
    };
    var templates;
    (function (templates) {
        templates.signUp = {
            stepReview: stepReview
        };
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
